import {datenschutzUrl, verbraucherschutzUrl} from "@/store/config/externalLinks";

/**
 * Defines menu items, depending on user
 *
 * @param {boolean} pksUser true if menu should be created for pks user
 * @param {string} userText text to display as user name
 * @returns full menu
 */
export function menuItems(userRights, userText) {
  const kundenverwaltungsItems = [];
  if (userRights.angebote) {
    kundenverwaltungsItems.push({
      title: 'Angebote',
      path: '/angebote',
      description: 'Angebotsübersicht'
    });
  }
  if (userRights.antraege) {
    kundenverwaltungsItems.push({
      title: 'offene Anträge',
      path: '/offeneAntraege',
      description: 'Antragsübersicht'
    });
  }
  if (userRights.bestand) {
    kundenverwaltungsItems.push({
      title: 'Bestandsverträge',
      path: '/bestand',
      description: 'Übersicht und Änderung'
    });
    kundenverwaltungsItems.push({
      title: 'Schäden',
      path: '/schaden',
      description: 'Schadenübersicht'
    });
  }
  if (userRights.pks) {
    kundenverwaltungsItems.push({
      title: 'Antrags-/Angebotssuche',
      path: '/antragssuche',
      description: 'Einzel-Antrags-/Angebotssuche (PKS)'
    });
    kundenverwaltungsItems.push({
      title: 'Makler-Aktivierung',
      path: '/makleractivation',
      description: 'Maklerportalzugriff/Initialpasswort (PKS)'
    });
  }
  const benutzerprofilItems = [];
  if (userRights.profil) {
    benutzerprofilItems.push({
      title: 'Mein Profil',
      path: '/benutzerprofil',
      description: 'Benutzerprofil einsehen und bearbeiten'
    });
  }
  benutzerprofilItems.push({
    title: 'Überblick',
    path: '/onboarding',
    description: 'Neue Funktionen im Maklerportal'
  });
  if (userRights.courtagen) {
    benutzerprofilItems.push({
      title: 'Courtage-Abrechnungen',
      path: '/courtagen',
      description: 'Übersicht Ihrer Abrechnungen'
    });
  }
  benutzerprofilItems.push({
    title: 'Abmelden',
    path: '/logout',
    description: 'Auf Wiedersehen!'
  });
  const angebotsrechnerItems = [{
    title: 'Privatkunden',
    path: '/privatkunden',
    description: 'Angebot erstellen'
  }];
  if (userRights.gewerberechner) {
    angebotsrechnerItems.push({
      title: 'Gewerbetreibende/Selbstständige',
      path: '/gewerbekundenangebot',
      description: 'Angebot erstellen'
    });
  }
  if (userRights.aerzterechner) {
    angebotsrechnerItems.push({
      title: 'Ärzte/Heilberufe',
      path: '/komedex',
      description: 'Angebot erstellen'
    });
  }
  angebotsrechnerItems.push({
    title: 'Land-/Forstwirte',
    path: '/landwirtschaft',
    description: 'Angebot erstellen'
  });

  return {
    menuUser: {
      key: 'menuUser',
      icon: 'account_circle',
      title: userText || '',
      items: benutzerprofilItems
    },
    menuAngebotsrechner: {
      title: 'Angebotsrechner',
      key: 'menuAngebotsrechner',
      items: angebotsrechnerItems
    },
    menuProdukte: {
      title: 'Produkte',
      key: 'menuProdukte',
      items: [
        {
          title: 'Privatkunden',
          path: '/produkte/privatkunden',
          description: 'Produktübersicht'
        },
        {
          title: 'Gewerbetreibende/Selbstständige',
          path: '/produkte/gewerbe',
          description: 'Produktübersicht'
        },
        {
          title: 'Ärzte/Heilberufe',
          path: '/produkte/aerzte',
          description: 'Produktübersicht'
        },
        {
          title: 'Land-/Forstwirte',
          path: '/produkte/landwirte',
          description: 'Produktübersicht'
        },
        {
          title: 'Service für Kunden',
          path: '/soforthilfe',
          description: 'DMB RECHT Serviceleistungen'
        }
      ]
    },
    menuKundenverwaltung: {
      title: 'Kundenverwaltung',
      key: 'menuKundenverwaltung',
      items: kundenverwaltungsItems
    },
    menuVertriebsunterstuetzung: {
      title: 'Vertriebsunterstützung',
      key: 'menuVertriebsunterstuetzung',
      items: [
        {
          title: 'Service für Makler',
          path: '/vertriebsunterstuetzung/maklerservice',
          description: 'Persönliche Ansprechpartner'
        },
        {
          title: 'Verkaufshilfen',
          path: '/vertriebsunterstuetzung/verkaufshilfen',
          description: 'Verkaufsansätze und Schadenbeispiele' //(alternativ falls zu lang: Argumente und Schadenbeispiele)
        },
        {
          title: 'Recht: aktuell',
          path: '/vertriebsunterstuetzung/rechtAktuell',
          description: 'Neuigkeiten DMB Rechtsschutz'
        },
        {
          title: 'Online-Schulungen',
          path: 'https://anmeldung.csn.de/dmb-rechtsschutz',
          description: 'Termine und Themen'
        },
        {
          title: 'Prozesskostenrechner',
          path: 'https://prozesskostenrechner-dmb.dahag-web.de/',
          description: 'Kosten eines Rechtsstreits berechnen'
        },
        {
          title: 'SEPA',
          path: '/vertriebsunterstuetzung/SEPA',
          description: 'SEPA-Lastschrift-Mandat'
        }
      ]
    },
    menuAbout: {
      title: 'Über uns',
      key: 'menuAbout',
      items: [
        {
          title: 'Unternehmen',
          path: '/unternehmen',
          description: 'Zahlen und Fakten'
        },
        {
          title: 'Presse',
          path: '/presse',
          description: 'Berichte und Beiträge'
        },
        {
          title: 'Auszeichnungen',
          path: '/auszeichnungen',
          description: 'Produkt-Ratings und Bewertungen'
        },
        {
          title: 'Datenschutz',
          path: datenschutzUrl,
          description: 'Unsere Datenschutzerklärung'
        },
        {
          title: 'Verbraucherschutz',
          path: verbraucherschutzUrl,
          description: 'Alles zum Verbraucherschutz'
        }
      ]
    }
  };
}
